import axios from "axios";
import { connectorAddEdit } from "../../constants/Presets";

export function ValidateConnector(connector) {
  const url = `${connectorAddEdit}/checkParamValidity`;
  return axios.post(url, connector);
}
